import { useEffect, useState } from 'react'
import { useHistory, useLocation, Link } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { apiFetch } from '@/lib/apiFetch'
import { timArt } from '@/lib/timArt'

export default function MagicLoginPage() {
  const { refresh } = useAuth()
  const history = useHistory()
  const location = useLocation()
  const token = new URLSearchParams(location.search).get('token')
  const [error, setError] = useState('')
  const [verifying, setVerifying] = useState(true)

  useEffect(() => {
    if (!token) {
      setError('No login token found.')
      setVerifying(false)
      return
    }

    apiFetch('/app/magic-link/verify', {
      method: 'POST',
      body: JSON.stringify({ token }),
    })
      .then(async () => {
        await refresh()
        history.replace('/dashboard')
      })
      .catch((err) => {
        setError(err.message || 'Login link is invalid or expired.')
        setVerifying(false)
      })
  }, [token])

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm space-y-6 text-center">
        <img
          src={timArt('neutral')}
          alt="Tim"
          className="w-24 h-24 mx-auto object-contain mb-4"
        />
        {verifying ? (
          <p className="text-muted-foreground">Logging you in...</p>
        ) : error ? (
          <>
            <div className="p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm">
              {error}
            </div>
            <Link to="/login" className="text-primary font-medium hover:underline text-sm">
              Back to login
            </Link>
          </>
        ) : null}
      </div>
    </div>
  )
}
